import { useLocation } from "react-router-dom";
import { Column } from "./Column";
import { Row } from "./Row";
import { TextComponent } from "./TextComponent";

export const PurchaseSuccessful = () => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const suscriptionPlanId = queryParams.get("suscription_plan_id");
	const productId = queryParams.get("product_id");

	const message = suscriptionPlanId
		? "Thank you for subscribing to our plan!"
		: productId
		? "Thank you for purchasing our product!"
		: "Your purchase was completed successfully.";

	return (
		<Column className="w-full">
			<Row className="max-sm:flex-col bg-white p-10 h-svh overflow-y-auto overflow-x-hidden self-center w-full max-w-[70rem] gap-5 sm:gap-10">
				<img
					src="/congratulations.jpg"
					alt="Congratulations"
					className="sm:w-1/2 object-contain"
				/>
				<Column
					mainAxisAlignment="center"
					className="sm:w-1/2 gap-5 sm:gap-10"
				>
					<TextComponent
						variant="extraBig"
						className="text-primary font-bold"
					>
						Congratulations!
					</TextComponent>
					<Column className="gap-2 md:gap-4">
						<TextComponent variant="h2">{message}</TextComponent>
						<TextComponent variant="h2">
							You can now close this page.
						</TextComponent>
					</Column>
				</Column>
			</Row>
		</Column>
	);
};
